export enum OptionType {
  WAYPOINTS = 'WAYPOINTS',
  GO_TO_LOCATION = 'GO_TO_LOCATION',
  MEASUREMENT_TOOL = 'MEASUREMENT_TOOL',
  CREATE_PRINT_MAP = 'CREATE_PRINT_MAP'
}

export interface OptionItem {
  type: OptionType;
  name: string;
  icon: string;
  isPro: boolean;
  action: () => void;
}

export const optionConfig: Record<OptionType, Omit<OptionItem, 'action'>> = {
  [OptionType.WAYPOINTS]: {
    type: OptionType.WAYPOINTS,
    name: 'Waypoints',
    icon: 'place',
    isPro: false
  },
  [OptionType.GO_TO_LOCATION]: {
    type: OptionType.GO_TO_LOCATION,
    name: 'Go to location',
    icon: 'my_location',
    isPro: false
  },
  [OptionType.MEASUREMENT_TOOL]: {
    type: OptionType.MEASUREMENT_TOOL,
    name: 'Measurement tool',
    icon: 'straighten',
    isPro: true
  },
  [OptionType.CREATE_PRINT_MAP]: {
    type: OptionType.CREATE_PRINT_MAP,
    name: 'Create print map',
    icon: 'print',
    isPro: true
  }
};